import React from "react";
import { styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

import { DateTime } from "../datetime";

const ConsentHistoryInfoTextInner: React.FC<
  React.HTMLAttributes<HTMLDivElement> & {
    lastUpdated: {
      changeDate?: string;
      changedBy?: Maybe<{ firstName: string; lastName: string }>;
      updatingNow?: boolean;
    };
  }
> = ({ lastUpdated, ...props }) => {
  if (!lastUpdated.changeDate && !lastUpdated.updatingNow) return null;

  if (!lastUpdated.changeDate) {
    return <div {...props}>Will be updated now</div>;
  }

  return (
    <div {...props}>
      {lastUpdated.updatingNow ? "Will be updated now. " : null}
      Last updated on behalf of the Patient by{" "}
      {lastUpdated.changedBy ? `${lastUpdated.changedBy.firstName} ${lastUpdated.changedBy.lastName}` : "System"}
      {lastUpdated.changeDate ? (
        <>
          {" "}
          on <DateTime format={DateTime.FORMAT.DATE} value={lastUpdated.changeDate} />
        </>
      ) : null}
    </div>
  );
};

export const ConsentHistoryInfoText = styled(ConsentHistoryInfoTextInner)`
  ${typeScale.xs}
`;
